import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import { useDispatch, useSelector } from 'react-redux';
import { fetchShowcases } from '../../../../store/actions/showcasesActions';


const Showcases = () => {
    const dispatch = useDispatch();

    // CORREÇÃO: Seletores Redux ajustados
    const showcasesState = useSelector((state) => state.showcases);
    const {
        currentShowcase,
        loading: loadingShowcase,
        error: errorShowcase
    } = showcasesState || {};


    useEffect(() => {
        dispatch(fetchShowcases());
    }, [dispatch]);



    return (
                <div className="container">
                    <Helmet>
                        <title>Showcases</title>   
                    </Helmet>
                    <h1>Showcases</h1>
                    <div className="showcases-list">
                        {showcasesState.showcases.map((showcase) => (
                            <div key={showcase.id} className="showcase-item">
                                <h2>{showcase.title}</h2>
                            </div>
                        ))}
                    </div>
                </div>
    );
};

export default Showcases;